import { Play, UserPlus, FileText, Package } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface TriggerTypeConfig {
  icon: LucideIcon;
  label: string;
}

export const TRIGGER_TYPE_CONFIG = {
  PROGRAM_APPLIED: {
    icon: UserPlus,
    label: 'Member Applied'
  },
  PROGRAM_APPLICANT_APPROVED: {
    icon: UserPlus,
    label: 'Member Approved'
  },
  BRIEF_ACCEPTED: {
    icon: FileText,
    label: 'Brief Accepted'
  },
  BRIEF_SENT: {
    icon: FileText,
    label: 'Brief Sent'
  },
  DELIVERABLE_COMPLETED: {
    icon: FileText,
    label: 'Deliverable Completed'
  },
  DELIVERABLE_REJECTED: {
    icon: FileText,
    label: 'Deliverable Rejected'
  },
  DELIVERABLE_SUBMITTED: {
    icon: FileText,
    label: 'Deliverable Submitted'
  },
  PRODUCT_ORDER_DELIVERED: {
    icon: Package,
    label: 'Product Delivered'
  },
  PRODUCT_ORDER_REQUEST_SENT: {
    icon: Package,
    label: 'Product Requested'
  },
  SALES_TRACKING_FIRST_CONVERSION: {
    icon: Package,
    label: 'First Conversion'
  }
} as const;

export const getTriggerConfig = (triggerType?: string): TriggerTypeConfig => {
  const config = triggerType ? TRIGGER_TYPE_CONFIG[triggerType as keyof typeof TRIGGER_TYPE_CONFIG] : undefined;
  return config || { icon: Play, label: 'Trigger Event' };
};
